import { useState } from 'react';
import SvgIcon from '../../SvgIcon/SvgIcon';
import ProductUnitPopup from '../../Catalog/units/ProductUnitPopup';
import { IProductUnitCreate } from '../../../types/productUnit/productUnitInterfaces';

interface Props {
  onUnitCreated?: (data: IProductUnitCreate) => Promise<void> | void;
  onReload?: () => void;
  message?: string;
}

const QuickAddProductUnit: React.FC<Props> = ({
  onUnitCreated,
  onReload,
  message = '¿No encuentras la unidad de medida? Puedes agregar una nueva.',
}) => {

  const [isOpen, setIsOpen] = useState(false);

  const handleRegister = async (unitData: IProductUnitCreate) => {
    if (onUnitCreated) {
      await onUnitCreated(unitData);
    }
    setIsOpen(false);
  };

  return (
    <div
      className="
        mt-1 flex flex-col gap-2
        sm:flex-row sm:items-center sm:justify-between
      "
    >
      {/* Mensaje contextual */}
      <p className="text-gray-600 dark:text-gray-300 text-xs">
        {message}
      </p>

      {/* Botones */}
      <div className="flex items-center gap-2">

        {/* ✅ VERDE — Recargar */}
        <button
          onClick={onReload}
          type="button"
          className="
            inline-flex items-center gap-1 rounded
            bg-[#3CA745] py-1 px-2 text-xs font-medium text-white
            hover:bg-opacity-90 transition
          "
        >
          <SvgIcon name="refresh" className="h-3 w-3" />
          Recargar
        </button>

        {/* ✅ AZUL — Nueva Unidad */}
        <button
          onClick={() => setIsOpen(true)}
          type="button"
          className="
            inline-flex items-center gap-1 rounded
            bg-primary py-1 px-2 text-xs font-medium text-white
            hover:bg-opacity-90 transition
          "
        >
          <SvgIcon name="plus" className="h-3 w-3" />
          Nueva
        </button>
      </div>

      {/* Modal Popup */}
      <ProductUnitPopup
        popupOpen={isOpen}
        setPopupOpen={setIsOpen}
        onRegister={handleRegister}
      />
    </div>
  );
};

export default QuickAddProductUnit;
